// awardData.js
// ─── Add new awards here as you receive them ──────────────────

var awardData = [
  {
    id:          1,
    title:       'Best Software Lecturer 2025',
    issuer:      'Lincoln University Nusk Campus',
    location:    'Nasarawa State, Nigeria',
    date:        '2025',
    description: 'Awarded the title of Best Software Lecturer at Lincoln University Nusk Campus, Nasarawa State — in recognition of outstanding contributions to teaching, mentorship, and the advancement of software engineering education.',
    image:       '/jacob.jpeg',
    placeholder: false,
  },
  {
    id:          2,
    title:       'Coming Soon',
    issuer:      'Place Update',
    location:    '',
    date:        '2025',
    description: 'Place Update',
    image:       '',
    placeholder: true,
  },
  {
    id:          3,
    title:       'Coming Soon',
    issuer:      'Place Update',
    location:    '',
    date:        '2025',
    description: 'Place Update',
    image:       '',
    placeholder: true,
  },
];

export default awardData;